import { z } from 'zod'

export const clientCreateSchema = z.object({
	name: z.string().min(1),
	code: z.string().min(1),
	/**
	 * Parent client id (self-FK). NULL for top-level rows; a uuid for sub-clients.
	 * Admin callers pass the id directly; the seed migration resolves codes → uuids in SQL.
	 */
	parentClientId: z.uuid().nullable().optional(),
	/** Productive company id — free-text; not enforced as unique. */
	productiveCompanyId: z.string().nullable().optional(),
	legalEntity: z.string().nullable().optional(),
	countryRegion: z.string().nullable().optional(),
	isActive: z.boolean().default(true),
})

export const clientUpdateSchema = clientCreateSchema.partial()

export type ClientCreateInput = z.infer<typeof clientCreateSchema>
export type ClientUpdateInput = z.infer<typeof clientUpdateSchema>
